export const ID_FORNECEDOR_TAXA = 1;
export const LABEL_PAGAMENTO_TAXA = "Pagamento de Taxa";

export interface IOptionFornecedor {
  value: number | string;
  label: string;
}

const eTaxa = (value: number | string) => Number(value) === ID_FORNECEDOR_TAXA;

export function ordenarBeneficiariosComTaxa<T extends IOptionFornecedor>(
  options: T[],
): T[] {
  const relabel = options.map((opt) =>
    eTaxa(opt.value) ? { ...opt, label: LABEL_PAGAMENTO_TAXA } : opt,
  );
  const taxa = relabel.filter((opt) => eTaxa(opt.value));
  const demais = relabel.filter((opt) => !eTaxa(opt.value));
  return [...taxa, ...demais];
}
